export default {
	name: 'bookMangment',
	data() {
		return {
			areaID: this.$store.state.user.areaID,
			search: '',
			BooksID: 0,
			BooksName: '',
			BookBriefIntroduction: '',
			BookRecommend: '',
			WriterName: '',
			WriterID: 1,
			RecommendReason: '',
			WriterBooksReferences: '著',
			BorrowCount: '',
			BooksSate: 0,
			CategoryMenuName: [],
			BooksDesc: '',
			BelongTo: '',
			Tag: [],
			CategoryAttribute: [],
			ClassificationID: this.$store.state.Classification[0].ClassificationID,
			OperatorID: this.$store.state.user.UserID,
			CategoryMenu_2: this.$store.state.CategoryMenu[0].ChildrenMenu,
			CategoryMenu_3: [],
			tagText: '',
			WriterBooksReferencesType: ['著', '编', '译'],
			customCategory: [],
			books: [],
			Edit: '',
			getData: {},
			clear: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,

			setDisabled: {}

		};
	},
	created() {

		this.getData = function() {
			this.$request.request({
				url: 'books/getBooksBySearch',
				data: {
					pageCount: this.pageRows,
					pageIndex: this.pageIndex,
					searchText: this.search,
					areaID: this.areaID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.books = res.books;
					this.count = res.count;
				}
			});
		}
		this.clear = function() {
			this.BooksID = 0;
			this.BooksName = '';
			this.BookBriefIntroduction = '';
			this.BookRecommend = '';
			this.WriterName = '';
			this.WriterID = 1;
			this.RecommendReason = '';
			this.WriterBooksReferences = '著';
			this.BorrowCount = '';
			this.BooksSate = 0;
			this.BooksDesc = '';
			this.BelongTo = '';
			this.CategoryMenuName = "";
			this.Tag = [];
			this.CategoryID = this.$store.state.CategoryMenu[0].CategoryMenuID;
			this.CategoryAttribute = [];
			this.ClassificationID = this.$store.state.Classification[0].ClassificationID;
			this.OperatorID = this.$store.state.user.UserID;
			this.CategoryMenu_2 = this.$store.state.CategoryMenu[0].ChildrenMenu;
			this.CategoryMenu_3 = [];
			this.tagText = '';
			this.WriterBooksReferencesType = ['著', '编', '译'];
		}
		this.$store.dispatch('refresh');
		this.getData();
		this.setDisabled = function() {
			let myBooks = this.$refs.myBooks;

			for (let i of myBooks.getElementsByTagName('input'))
				i.disabled = 'disabled';
			for (let i of myBooks.getElementsByTagName('textarea'))
				i.disabled = 'disabled';
			for (let i of myBooks.getElementsByTagName('select'))
				i.disabled = 'disabled';
		}
	},
	methods: {
		searchBooks(e) {
			if (e.keyCode == 13)
				this.getData();
		},
		addTag() {
			if (this.tagText == "") return;
			this.Tag.push(this.tagText);
			this.tagText = '';
		},
		selectOne(i) {
			this.CategoryMenu_2 = i.ChildrenMenu;
			this.CategoryMenu_3 = [];
		},
		selectTwo(i) {
			this.CategoryMenu_3 = i.ChildrenMenu;
		},
		cancel() {
			this.Edit = '';
			this.clear();
		},
		updateBooks(i) {
			this.BooksID = i.BooksID;
			this.Edit = 'update';
			this.WriterID = i.WriterID;
			this.WriterName = i.WriterName;
			this.BooksName = i.BooksName;
			this.BookBriefIntroduction = i.BookBriefIntroduction;
			this.RecommendReason = i.RecommendReason;
			this.BookRecommend = i.BookRecommend;
			this.CategoryMenuName = i.CategoryMenuName.split(',');
			this.WriterID = i.WriterID;
			this.WriterBooksReferences = i.WriterBooksReferences;
			this.BooksSate = i.BooksSate;

			this.ClassificationID = i.ClassificationID;
			this.CategoryID = i.CategoryID;
			this.BelongTo = i.BelongTo;
			this.Tag = i.Tag.split(',');
			this.customCategory = (i.CustomCategory == "" || i.CustomCategory == null || i.CustomCategory == "null") ?
			[] : i.CustomCategory.split(',');
			this.CategoryAttribute = i.CategoryAttribute.split(',');
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length > 0 &&
				this.ClassificationID >
				0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {

	},
	mounted() {
		this.setDisabled();
	},
	activated() {
		this.getData();
	}

}
